import React, { useRef, useState } from "react";
import Heading from "@/components/Heading";
import { Form } from "@unform/web";
import * as Yup from "yup";
import InputMask from "@/components/InputMask";
import ModalPopup from "@/components/ModalPopup";
import { api } from "@/services/api";
import { useParams } from "react-router-dom";
import { validateCnpj, validateCpf } from "@/utils/validations";

import "bootstrap/dist/css/bootstrap-grid.min.css";
import { Container, LabelContainer } from "./styles";

export const UpdateSigin = () => {
	const { type } = useParams();
	const formRef = useRef(null);
	const [submit, setSubmot] = useState(false);
	const [modalPopup, setModalPopup] = useState(false);
	const [modalContent, setModalContent] = useState({
		title: "",
		content: "",
	});

	async function handleSubmit(data) {
		Yup.addMethod(Yup.string, "validateCnpj", validateCnpj);
		Yup.addMethod(Yup.string, "validateCpf", validateCpf);

		try {
			let schema;
			if (type === "merchant") {
				schema = Yup.object().shape({
					cnpj: Yup.string()
						.validateCnpj("CNPJ inválido")
						.required("Campo obrigatório"),
				});
			}

			if (type === "consumer") {
				schema = Yup.object().shape({
					cpf: Yup.string()
						.validateCpf("CPF inválido")
						.required("Campo obrigatório"),
				});
			}

			await schema.validate(data, {
				abortEarly: false,
			});

			handleReqUpdate(data);
			formRef.current.setErrors({});
		} catch (err) {
			if (err instanceof Yup.ValidationError) {
				const errorMessages = {};

				err.inner.forEach((error) => {
					errorMessages[error.path] = error.message;
				});

				formRef.current.setErrors(errorMessages);
			}
		}
	}

	function handleReqUpdate(data) {
		setSubmot(true);

		api.post(`${type}/consult`, data)
			.then((res) => {
				setSubmot(false);

				if (res.data.status === 200) {
					setModalPopup(true);
					setModalContent({
						title: "Programa Fidelidade GERIOOX",
						content: res.data.message,
					});
				}

				if (res.data.status === 400) {
					setModalPopup(true);
					setModalContent({
						title: "Ocorreu um problema!",
						content: res.data.message,
					});
				}
			})
			.catch((error) => {
				setSubmot(false);
				setModalPopup(true);
				setModalContent({
					title: "Ocorreu um problema!",
					content: "Ops! Não foi possível atender sua solicitação.",
				});
				console.error({ endPoint: `/${type}/recovery`, error });
			});
	}

	return (
		<Container>
			<ModalPopup
				visible={modalPopup}
				message={modalContent}
				onClick={() => setModalPopup(!modalPopup)}
			/>

			<Heading>
				<p className='title'>
					<span>Primeiro</span> acesso?
				</p>
			</Heading>

			<div className='container-fluid'>
				<div className='row justify-content-lg-center'>
					<div className='col-12 col-lg-4'>
						<span className='separator'></span>
						<Form
							ref={formRef}
							name='updateUser'
							onSubmit={handleSubmit}
							className='content'>
							<p>
								Para atualizar seus dados, preencha o campo
								abaixo com seu{" "}
								{type === "consumer" ? "CPF" : "CNPJ"} informado
								no cadastro. As instruções para atualização
								serão enviadas para o seu e-mail.
							</p>

							{type === "merchant" && (
								<LabelContainer>
									<InputMask
										label='CNPJ'
										name='cnpj'
										mask='99.999.999/9999-99'
										placeholder='00.000.000/0000-00'
									/>
								</LabelContainer>
							)}
							{type === "consumer" && (
								<LabelContainer>
									<InputMask
										label='CPF'
										name='cpf'
										mask='999.999.999-99'
										placeholder='000.000.000-00'
									/>
								</LabelContainer>
							)}

							<button
								type='submit'
								className='btn-secundary'
								disabled={submit ? "disabled" : ""}>
								{submit ? "enviando" : "enviar"}
							</button>
						</Form>
					</div>
				</div>
			</div>
		</Container>
	);
};

export default UpdateSigin;
